import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup } from '@angular/forms';
import { PriorityPatchRequest } from '@primatoo-ms-organization';
import { NUMBER_PATTERN, PATTERN_VALIDATOR_KEY, PtEntity, REQUIRED_VALIDATOR_KEY } from '@pt/pt-models';
import * as DocumentsUtils from '../documents/utils/validator-generator';

@Component({
  selector: 'pt-edit-entity-priority',
  template: `
    <div class='modal-header'
         (click)='$event.stopPropagation()'>
      <h4 class='modal-title'>
        {{ "TITLE.EDIT_PRIORITY" | translate }}
      </h4>
    </div>

    <div class='modal-body' (click)='$event.stopPropagation()'>
      <form [formGroup]='formGroup' *ngIf='formGroup'>
        <div class='form-group'>
          <pt-input-text
            [controlName]='"name"'
            formControlName='name'
            [validators]='[REQUIRED]'
            [label]="'LABELS.NAME' | translate"
            *ngIf='formGroup?.controls?.name.value'
            [ngbTooltip]='formGroup?.controls?.name.value'
          ></pt-input-text>

          <pt-input-text
            [controlName]='"value"'
            formControlName='value'
            [validators]='[REQUIRED, NUMBER]'
            [label]="'LABELS.VALUE' | translate"
          ></pt-input-text>
        </div>
      </form>
    </div>

    <div class='modal-footer' (click)='$event.stopPropagation()'>
      <button type='button' class='btn btn-primary btn-sm'
              [disabled]='formGroup?.invalid'
              (click)='submit(); $event.stopPropagation()'>
        {{ 'BUTTON.CONFIRM' | translate }}
      </button>

      <button ngbAutofocus type='button' class='btn btn-outline-secondary btn-sm'
              (click)='activeModal.close(false); $event.stopPropagation()'>
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
    </div>
  `
})
export class EditEntityPriorityDialogComponent implements OnInit {

  @Input() entity: PtEntity;
  @Input() payload: any;

  public formGroup: FormGroup;
  public REQUIRED = DocumentsUtils.ValidatorGenerator.generateWidgetValidator(REQUIRED_VALIDATOR_KEY);
  public NUMBER = DocumentsUtils.ValidatorGenerator.generateWidgetValidator(PATTERN_VALIDATOR_KEY, [NUMBER_PATTERN]);

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.formGroup = new FormGroup({
      name: new FormControl({value: this.payload?.name, disabled: true}),
      value: new FormControl(this.payload?.priority)
    });

    switch (this.entity) {
      case 'treatmentCategory':
      case 'technicalMeasureCategories':
      case 'organizationalMeasureCategories':
        this.formGroup.controls.name.setValue(this.payload?.label);
        break

      case 'technicalMeasures':
      case 'organizationalMeasures':
        this.formGroup.controls.name.setValue(this.payload?.idCheck);
        break;

      case 'preliminaryRiskAssessment':
        this.formGroup.controls.name.setValue(this.payload?.value);
        break;
    }
  }

  submit() {
    const request: PriorityPatchRequest = {
      value: Number(this.formGroup?.controls?.value.value)
    };
    this.activeModal.close(request);
  }
}

